import classnames from 'classnames'
import {Button} from '@mui/material'
import PropTypes from 'prop-types'

import StyledLinkText from './StyledLinkText'

const LinkButton = ({children, className, disabled, href, loading, onClick, ...otherProps}) => (
  <Button
    className={classnames('link-button', className)}
    disabled={disabled || loading}
    onClick={onClick}
    variant='text'
    {...otherProps}
    {...(href && {component: 'a', href})}>
    <StyledLinkText component='span'>{children}</StyledLinkText>
  </Button>
)

const onClickOrHrefRequired = (props, propName, componentName, ...rest) => {
  const onClickTypeError = PropTypes.func(props, propName, componentName, ...rest)
  if (onClickTypeError)
    return onClickTypeError

  if (props.href || typeof props[propName] === 'function')
    return null

  return new Error(
    `Invalid prop \`${propName}\` supplied to \`${componentName}\`. ` +
      'Provide either `href` or `onClick` to avoid rendering an inert control.'
  )
}

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  loading: PropTypes.bool,
  onClick: onClickOrHrefRequired
}

export default LinkButton
